import { render, staticRenderFns } from "./incidences_panel.vue?vue&type=template&id=4606ed18"
import script from "./incidences_panel.vue?vue&type=script&lang=js"
export * from "./incidences_panel.vue?vue&type=script&lang=js"
import style0 from "./incidences_panel.vue?vue&type=style&index=0&id=4606ed18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports